import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createPolicyData, createTnc, getPolicy, getTnc, updatePolicy, updateTnc, createQna, getQnaList, getQnaById, updateQna, deleteQna, createAboutUs, getAboutUs, updateAboutUs } from '../api/appInfo';

export const useCreatePolicyData = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (data) => createPolicyData(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['app-policy']);
        },
    });
};

export const useGetAppPolicy = () => {
    return useQuery({
        queryKey: ['app-policy'],
        queryFn: () => getPolicy(),
    });
};

export const useUpdatePolicy = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (data) => updatePolicy(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['app-info']);
        },
    });
};

export const useCreateTnc = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (data) => createTnc(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['app-tnc']);
        },
    });
};

export const useGetAppTnc = () => {
    return useQuery({
        queryKey: ['app-tnc'],
        queryFn: () => getTnc(),
    });
};

export const useUpdateTnc = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (data) => updateTnc(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['app-tnc']);
        },
    });
};

export const useGetAboutUs = (id) => {
    return useQuery({
        queryKey: ['about-us', id],
        queryFn: () => getAboutUs(id),
        enabled: !!id,
    });
}

export const useCreateAboutUs = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (data) => createAboutUs(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['about-us']);
        },
    });
};

export const useUpdateAboutUs = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (data) => updateAboutUs(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['about-us']);
        },
    });
};

// QnA Query Hooks
export const useCreateQna = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (data) => createQna(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['qna-list']);
        },
    });
};

export const useGetQnaList = () => {
    return useQuery({
        queryKey: ['qna-list'],
        queryFn: () => getQnaList(),
    });
};

export const useGetQnaById = (id) => {
    return useQuery({
        queryKey: ['qna', id],
        queryFn: () => getQnaById(id),
        enabled: !!id,
    });
};

export const useUpdateQna = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (data) => updateQna(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['qna-list']);
        },
    });
};

export const useDeleteQna = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: (id) => deleteQna(id),
        onSuccess: () => {
            queryClient.invalidateQueries(['qna-list']);
        },
    });
};
